// import Vue from 'vue'
import baseContextComponent from "@/components/baseContextComponent";
import { AnagraficaDistributoreEdit } from "@/models/anafrafica/AnagraficaDistributore";
import { PartecipanteItem } from "@/models/ricercaGaranzie/partecipanteItem";
import { TextValueItem } from "@/models/TextValueItem";
import api from "@/services/api";
import { Component, Prop, Watch } from "vue-property-decorator";
import gridComponentBase from "../../../components/grid/gridComponentBase.vue";
import { VNode } from "vue/types/umd";
import { EseguiComandoRequest } from "@/models/comandi/eseguiComandoRequest";
import permessi from "@/config/permessi";
import apiFile from "@/services/apiFile";
import { RigaCarrello } from "@/models/carrello/rigaCarrello";
import helpers from "@/helpers";
import { modificheAmmesseProdotto } from "@/models/prodotti/modificheAmmesseProdottiItem";

const _ENDPONT_MODIFICHE_AMMESSE_PRODOTTO = api.endpoint.PRODOTTI.MODIFICHE_AMMESSE_PRODOTTI;

@Component({})
export default class ricercaGaranziePage extends gridComponentBase {
	get PERMESSI(): string[] {
		return [permessi.BK.Vendite.MODIFICA_PRATICA_AVANZATA];
	}
	
	@Prop({ default: () => null }) pacchettoID: number;
	
	//distributori: Array<TextValueItem> = [];
	//pacchetti: Array<TextValueItem> = [];
	//parametri: RigaCarrello = new RigaCarrello();

	datiCaricati: boolean = false;
	modificheAmmesse: modificheAmmesseProdotto = null;

	mounted() {
		//this.parametri.adeguatezza = true; // uso campo adeguatezza per indicare se devo registrare la modifica
		var self = this;
		// var p = [
		// 	api.getDatiDropDown(api.endpoint.DROPDOWN.DISTRIBUTORI_UTENTI).then(res => (self.distributori = res)),
		// 	api.getDatiDropDown(api.endpoint.DROPDOWN.PACCHETTI).then(res => (self.pacchetti = res))
		// ];
		// Promise.all(p)
		// 	.then(responses => {
		// 		self.loading = false;
		// 	})
		// 	.catch(err => {
		// 		console.log(err);
		// 	});

		api.get(`${_ENDPONT_MODIFICHE_AMMESSE_PRODOTTO}/${this.pacchettoID}`).then(res => 
		{
			debugger
			if(res)
				self.modificheAmmesse = res;
			else
				self.modificheAmmesse = new modificheAmmesseProdotto();
			self.datiCaricati = true;
		});
		
	}


	aggiornaModificheAmmesse() {
		var dati = helpers.cloneObject(this.modificheAmmesse) as modificheAmmesseProdotto;
		dati.pacchettoID = this.pacchettoID;
		
		var self = this;
		api.chiamataPost(_ENDPONT_MODIFICHE_AMMESSE_PRODOTTO, dati)
			.then(res => {
				self.$bvToast.toast("Modifiche aggiornate".toString(), {
					variant: "success",
					title: "Pratica modificata",
					solid: true
				});
				
				self.modificheAmmesse = res.data as modificheAmmesseProdotto;
			})
			.catch(err => {
			});
		}

}
